export default "__VITE_ASSET__PWFrn5sL__"